import { api, formatApiError } from "./api";
import { toast } from "sonner";

let scriptPromise = null;

function loadRazorpayScript() {
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay script"));
    document.body.appendChild(s);
  });
  return scriptPromise;
}

/**
 * Open Razorpay checkout for a payment initiated by the backend.
 * `init` is the payload returned by /api/checkout or /api/subscribe with requires_payment=true.
 * `user` is the current user (for prefill).
 * Returns a promise that resolves with the verify response on success.
 */
export async function openRazorpayCheckout(init, user) {
  if (!init?.razorpay_order_id) throw new Error("Missing razorpay order id");
  await loadRazorpayScript();
  return new Promise((resolve, reject) => {
    const options = {
      key: init.key_id,
      amount: init.amount,
      currency: init.currency || "INR",
      name: "Trinity Layers",
      description: init.kind === "subscription"
        ? `Subscription — ${init.plan_name || "Plan"}`
        : "Shop order",
      order_id: init.razorpay_order_id,
      prefill: {
        name: user?.name || "",
        email: user?.email || "",
      },
      theme: { color: "#2563EB" },
      modal: {
        ondismiss: () => reject(new Error("Payment cancelled")),
      },
      handler: async (res) => {
        try {
          const { data } = await api.post("/payments/verify", {
            order_id: init.order_id,
            kind: init.kind || "shop",
            razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_signature: res.razorpay_signature,
          });
          resolve(data);
        } catch (e) {
          reject(new Error(formatApiError(e.response?.data?.detail) || "Verification failed"));
        }
      },
    };
    try {
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", (resp) => {
        toast.error(resp.error?.description || "Payment failed");
        reject(new Error(resp.error?.description || "Payment failed"));
      });
      rzp.open();
    } catch (e) {
      reject(e);
    }
  });
}
